import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { InfoIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const EnrollmentConversionToggleInfo = ({
  enabledCount,
  limit,
  isEnablementRecommended
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    justifyContent: "center",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      gap: "100",
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: enabledCount === limit ? 'automation.enrollmentConversion.panel.tracking-toggle.addMetricsSlots' : 'automation.enrollmentConversion.panel.tracking-toggle.metricsSlots',
        options: {
          count: /*#__PURE__*/_jsx(Text, {
            as: "span",
            children: enabledCount
          }),
          limit: /*#__PURE__*/_jsx(Text, {
            as: "span",
            children: limit
          })
        }
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation.enrollmentConversion.panel.tracking-toggle.tooltips.inUse"
        }),
        children: /*#__PURE__*/_jsx(InfoIcon, {
          size: "100"
        })
      })]
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      gap: "100",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: isEnablementRecommended ? 'automation.enrollmentConversion.panel.tracking-toggle.metricsRecommended' : 'automation.enrollmentConversion.panel.tracking-toggle.metricsNotRecommended'
      }), /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: isEnablementRecommended ? 'automation.enrollmentConversion.panel.tracking-toggle.tooltips.recommended' : 'automation.enrollmentConversion.panel.tracking-toggle.tooltips.notRecommended'
        }),
        children: /*#__PURE__*/_jsx(InfoIcon, {
          size: "100"
        })
      })]
    })]
  });
};
export default EnrollmentConversionToggleInfo;